/* eslint-disable @typescript-eslint/no-misused-promises */
import React from "react"
import {CTA} from "@next/cta"
import {LinearProgress, Typography} from "@mui/material"
import {LOAD_MORE, PRODUCT_LOAD_TRIGGER} from "../../models/PageLoadTrigger"
import connect from "./connect"
import {LoadMoreButtonContainer, LoadMoreButtonInnerContainer} from "./components"

export interface LoadMoreButton {
    isFetchingNextPage: boolean
    productLoadTrigger: PRODUCT_LOAD_TRIGGER
    hasNextPage: boolean
    totalResults: number
    itemsLoaded: number
    fetchNextPage: () => Promise<any>
}

export const LoadMoreArea = ({
    isFetchingNextPage,
    hasNextPage,
    productLoadTrigger,
    totalResults,
    itemsLoaded,
    fetchNextPage,
}: LoadMoreButton) => {
    const handleLoadMore = async () => {
        await fetchNextPage()
    }

    const progressBarValue = (itemsLoaded / totalResults) * 100 > 100 ? 100 : (itemsLoaded / totalResults) * 100

    if (isFetchingNextPage || productLoadTrigger !== LOAD_MORE) return null
    return (
        <LoadMoreButtonContainer data-testid="load-more-area" data-productsEnd="true">
            <Typography data-testid="load-more-area-count-text">{`You've viewed ${itemsLoaded} of ${totalResults} products`}</Typography>
            <LinearProgress
                data-testid="load-more-progress"
                sx={{width: 250}}
                variant="determinate"
                value={progressBarValue}
            />
            {hasNextPage && (
                <LoadMoreButtonInnerContainer>
                    <CTA
                        onClick={handleLoadMore}
                        text="Load More"
                        enable={hasNextPage}
                        themeType="Primary"
                        testId="load-more-button"
                    />
                </LoadMoreButtonInnerContainer>
            )}
        </LoadMoreButtonContainer>
    )
}

export default connect(LoadMoreArea)
